var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayDisableNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 1.5C1.26268 1.5 0.666016 2.09667 0.666016 2.83333V11.3333C0.666016 12.07 1.26268 12.6667 1.99935 12.6667H5.33268V13.3333C5.33268 13.7013 5.63135 14 5.99935 14H9.99935C10.3673 14 10.666 13.7013 10.666 13.3333V12.6667H13.9993C14.736 12.6667 15.3327 12.07 15.3327 11.3333V2.83333C15.3327 2.09667 14.736 1.5 13.9993 1.5H1.99935ZM2.66602 2.83333H13.3327C13.7007 2.83333 13.9993 3.132 13.9993 3.5V10.6667C13.9993 11.0347 13.7007 11.3333 13.3327 11.3333H2.66602C2.29802 11.3333 1.99935 11.0347 1.99935 10.6667V3.5C1.99935 3.132 2.29802 2.83333 2.66602 2.83333Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_2030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.40001 4.8C6.34884 4.8 6.29761 4.81949 6.25861 4.85859L5.85861 5.25859C5.78041 5.33679 5.78041 5.4634 5.85861 5.5414L7.3172 7L5.85861 8.45859C5.78041 8.53679 5.78041 8.6634 5.85861 8.7414L6.25861 9.1414C6.33681 9.2196 6.46342 9.2196 6.54142 9.1414L8.00001 7.68281L9.45861 9.1414C9.53661 9.2196 9.66342 9.2196 9.74142 9.1414L10.1414 8.7414C10.2196 8.6632 10.2196 8.53659 10.1414 8.45859L8.68283 7L10.1414 5.5414C10.2196 5.4634 10.2196 5.33659 10.1414 5.25859L9.74142 4.85859C9.66322 4.78039 9.53661 4.78039 9.45861 4.85859L8.00001 6.31719L6.54142 4.85859C6.50232 4.81949 6.45119 4.8 6.40001 4.8Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayDisableNotificationIcon);
export default __webpack_public_path__ + "static/media/displayDisableNotificationIcon.21bfac5dee0482ccec13e20a2b8edf9e.svg";
export { ForwardRef as ReactComponent };